import { FilterMatchMode } from "primereact/api";

export class Actividad {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            actividad: {
                value: null,
                export: false,
                table: true,
                header: 'Actividades económicas:',
                required: 'Actividad es requerida',
                matchMode: FilterMatchMode.CONTAINS,
            },
            bien_servicio: {
                value: '',
                table: true,
                header: 'Bienes o Servicios que ofrecen:',
                required: 'Bien o Servicio es requerido',
                maxLength: 'Máximo 350 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 350,
                min: 4,
            },            
        }
    }

    optionLabel = 'nombre';
}
